<template>
  <div>
    <v-col sm="12" md="12" lg="12">
      <div v-if="displayTooltip">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="field.text"
              :label="field.label"
              outlined
              class="iol-v-text-field"
              type="text"
              :readonly="isReadonly"
              :disabled="isDisabled"
              v-on="on"
            />
          </template>
          <span>{{ field.tooltip }}</span>
        </v-tooltip>
      </div>
      <div v-else>
        <v-text-field
          v-model="field.text"
          :label="field.label"
          outlined
          class="iol-v-text-field"
          type="text"
          :readonly="isReadonly"
          :disabled="isDisabled"
        />
      </div>
    </v-col>
  </div>
</template>

<script>
import and from 'vuelidate/lib/validators/and'
export default {
  name: 'iol-number-field',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
  computed: {
    displayTooltip() {
      return this.field.tooltip !== undefined && this.field.tooltip !== ''
    },
    isReadonly() {
      return this.field.readonly !== undefined && this.field.readonly === true
    },
    isDisabled() {
      return this.field.disabled !== undefined && this.field.disabled === true
    },
  },
}
</script>

<style>
/* .iol-v2-text-field.v-text-field.v-text-field .v-input__control .v-input__slot {
  background-color: #fff;
  min-height: 0px !important;
  padding: 0 8px !important;
  margin-bottom: 2px !important;
  display: flex !important;
  align-items: center !important;
}
.iol-v2-text-field.v-text-field.v-text-field
  .v-input__control
  .v-input__slot
  label {
  margin-top: -12px !important;
}
.iol-v2-text-field.v-text-field.v-text-field
  .v-input__control
  .v-input__slot
  label.v-label--active {
  margin: -3px 0 0 5px !important;
} */
</style>
